import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { ThemeVariables } from "../types/themeVariablesTypes";

// Access themeVariables from the window object
// It's good practice to ensure it exists and has the expected properties.
const themeVariables = ((window as any).themeVariables as ThemeVariables) || {};

// Define a service using a base URL and expected endpoints for WooCommerce Store API
export const wcStoreApi = createApi({
  reducerPath: "wcStoreApi",
  baseQuery: fetchBaseQuery({
    // Use the storeApiUrl from themeVariables if available, otherwise fallback.
    baseUrl: themeVariables.storeApiUrl || "/wp-json/wc/store/v1/",
    prepareHeaders: (headers) => {
      // No custom headers needed for public product fetching
      // If you were to add nonce/cart-token for other operations, it would go here.
      return headers;
    },
  }),
  tagTypes: ["Product"], // Note: These are for WC Store API, consider namespacing if confusion arises
  endpoints: () => ({}),
});

// Define a new service for WordPress REST API
export const wpRestApi = createApi({
  reducerPath: "wpRestApi",
  baseQuery: fetchBaseQuery({
    baseUrl: themeVariables.wpRestApiUrl || "/wp-json/wp/v2/",
    prepareHeaders: (headers) => {
      if (themeVariables.wpRestApiNonce) {
        headers.set("X-WP-Nonce", themeVariables.wpRestApiNonce);
      }
      return headers;
    },
  }),
  tagTypes: ["WPCategory", "WPTag"], // Tags for WP REST API taxonomies
  endpoints: () => ({}),
});

// Export the api related utilities
// For wcStoreApi
export const {
  util: { getRunningQueriesThunk },
  reducer: wcStoreApiReducer, // Renamed to avoid conflict
  middleware: wcStoreApiMiddleware, // Renamed to avoid conflict
} = wcStoreApi;

// For wpRestApi - export its own reducer and middleware if you plan to use them separately
// or combine them in the store configuration.
export const { reducer: wpRestApiReducer, middleware: wpRestApiMiddleware } =
  wpRestApi;
